export enum PublicLocationApiUrls {
  GetPublicLocationsByJobId = '/api/PublicLocation/GetPublicLocationsByJobId',
  GetPublicLocationsBySegmentId = '/api/PublicLocation/GetPublicLocationsBySegmentId',
  GetUnAssignedPublicLocationsByPlanId = '/api/PublicLocation/GetUnAssignedPublicLocationsByPlanId',
  UpdatePublicLocationJobAndSequence = '/api/PublicLocation/UpdatePublicLocationsJobAndSequence',
}
